import { NavLink } from "react-router-dom";
import { Home, Search, CalendarDays, MessageSquareMore } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// V3 mobile shell: bottom navigation with Aufgaben, Vorgänge, Support and Mehr (opens the full menu).
export function MobileNav({ onMore, moreOpen }) {
  const { user } = useAuth();
  const allowed = user?.permissions?.includes("*") ? null : user?.allowed_menu || [];
  const items = [
    { key: "tasks", to: "/aufgaben", label: "Aufgaben", icon: Home },
    { key: "search", to: "/suche", label: "Vorgänge", icon: Search, menu: "overview" },
    { key: "support", to: "/support", label: "Support", icon: CalendarDays },
  ].filter((i) => !allowed || allowed.includes(i.menu || i.key));
  const cls = (active) => `flex min-h-[56px] flex-1 flex-col items-center justify-center gap-1 text-xs font-semibold ${active ? "text-brand-magenta" : "text-brand-purple"}`;
  return (
    <nav aria-label="Mobile Navigation" className="fixed inset-x-0 bottom-0 z-30 flex border-t border-[#E6E1F0] bg-white pb-[env(safe-area-inset-bottom)] lg:hidden" data-testid="mobile-bottom-nav">
      {items.map((i) => (
        <NavLink key={i.key} to={i.to} data-testid={`mobile-nav-${i.key}`} className={({ isActive }) => cls(isActive && !moreOpen)}>
          {({ isActive }) => (
            <>
              <i.icon className="h-5 w-5" aria-hidden="true" />{i.label}
              <span className={`h-0.5 w-8 rounded-full ${isActive && !moreOpen ? "bg-brand-magenta" : "bg-transparent"}`} aria-hidden="true" />
            </>
          )}
        </NavLink>
      ))}
      <button type="button" onClick={onMore} aria-expanded={moreOpen} data-testid="mobile-nav-more" className={cls(moreOpen)}>
        <MessageSquareMore className="h-5 w-5" aria-hidden="true" />Mehr
        <span className={`h-0.5 w-8 rounded-full ${moreOpen ? "bg-brand-magenta" : "bg-transparent"}`} aria-hidden="true" />
      </button>
    </nav>
  );
}
